import {
  AE,
  AM,
  AZ,
  BY,
  CA,
  CN,
  CY,
  CZ,
  DE,
  EE,
  ES,
  FI,
  FR,
  GB,
  GE,
  ID,
  IL,
  IN,
  IT,
  KG,
  KZ,
  LT,
  LV,
  MD,
  ME,
  NL,
  PL,
  RS,
  RU,
  TH,
  TJ,
  TM,
  TR,
  UA,
  US,
  UZ,
  VN,
} from 'country-flag-icons/react/3x2';
import type { ComponentType } from 'react';

import type { CountryCode } from './parsers/phone.ts';

/**
 * Флаги стран, откуда чаще всего бывают клиенты студии, — в порядке показа в списке.
 * Все 250 флагов весят около мегабайта; у остальных стран — плашка с кодом.
 */
const FLAGS: readonly [CountryCode, ComponentType<{ className?: string; title?: string }>][] = [
  ['RU', RU],
  ['KZ', KZ],
  ['BY', BY],
  ['UZ', UZ],
  ['KG', KG],
  ['AM', AM],
  ['GE', GE],
  ['AZ', AZ],
  ['TJ', TJ],
  ['TM', TM],
  ['MD', MD],
  ['UA', UA],
  ['AE', AE],
  ['TR', TR],
  ['CY', CY],
  ['IL', IL],
  ['RS', RS],
  ['ME', ME],
  ['DE', DE],
  ['GB', GB],
  ['US', US],
  ['CA', CA],
  ['FR', FR],
  ['IT', IT],
  ['ES', ES],
  ['NL', NL],
  ['PL', PL],
  ['CZ', CZ],
  ['FI', FI],
  ['EE', EE],
  ['LV', LV],
  ['LT', LT],
  ['CN', CN],
  ['IN', IN],
  ['TH', TH],
  ['VN', VN],
  ['ID', ID],
];

const SIZE = 'h-3! w-[1.125rem]! shrink-0 rounded-[2px] shadow-[0_0_0_1px_var(--g-border-soft)]';

/** Готовые элементы флагов: один раз при загрузке, а не новый компонент на каждый показ. */
const RENDERED = new Map(FLAGS.map(([code, Flag]) => [code, <Flag key={code} className={SIZE} />]));

/** Частые страны — первыми в списке выбора. */
export const POPULAR_COUNTRIES: readonly CountryCode[] = FLAGS.map(([code]) => code);

/** Флаг 3:2 высотой 12 px; страны без флага — плашка с двухбуквенным кодом. */
export function CountryFlag({ code }: { code: CountryCode }) {
  return (
    RENDERED.get(code) ?? (
      <span
        aria-hidden="true"
        className={`${SIZE} grid place-items-center bg-surface-2 text-[0.5rem] leading-none font-bold text-muted`}
      >
        {code}
      </span>
    )
  );
}
